import React, { useState } from 'react';
import { Phone, MessageCircle, X } from 'lucide-react';

export default function FloatingActions() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
        <a
          href="https://api.whatsapp.com/send?phone=919979111925"
          target="_blank"
          rel="noreferrer"
          className="w-12 h-12 rounded-full bg-[#25D366] hover:bg-[#1ebe5d] text-white flex items-center justify-center shadow-lg transition-transform hover:scale-110"
          aria-label="WhatsApp"
        >
          <MessageCircle className="w-5 h-5" fill="currentColor" />
        </a>
        <button
          onClick={() => setOpen(true)}
          className="px-5 h-12 rounded-full bg-[#7a1a2a] hover:bg-[#5a1220] text-white text-[11px] tracking-[0.2em] uppercase flex items-center gap-2 shadow-lg transition-colors"
        >
          <Phone className="w-4 h-4" /> Request Call Back
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white w-full max-w-md p-8 relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-[#1a1a1a] hover:text-[#7a1a2a]" aria-label="Close"><X className="w-5 h-5" /></button>
            <div className="text-[11px] tracking-[0.4em] uppercase text-[#7a1a2a] mb-2">Get in Touch</div>
            <h3 className="serif text-3xl font-light text-[#1a1a1a] mb-6">Request a Call Back</h3>
            <form onSubmit={(e) => { e.preventDefault(); setOpen(false); }} className="space-y-4">
              <input required placeholder="Full Name" className="w-full border-b border-neutral-300 focus:border-[#7a1a2a] outline-none py-3 text-sm" />
              <input required type="tel" placeholder="Phone Number" className="w-full border-b border-neutral-300 focus:border-[#7a1a2a] outline-none py-3 text-sm" />
              <input type="email" placeholder="Email Address" className="w-full border-b border-neutral-300 focus:border-[#7a1a2a] outline-none py-3 text-sm" />
              <textarea rows={3} placeholder="Message" className="w-full border-b border-neutral-300 focus:border-[#7a1a2a] outline-none py-3 text-sm resize-none" />
              <button type="submit" className="w-full bg-[#7a1a2a] hover:bg-[#5a1220] text-white py-3 text-[11px] tracking-[0.3em] uppercase transition-colors">Submit</button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
